import { Component, Input, OnInit } from '@angular/core';
import { BankingAccountService } from '../banking-account.service';
import { BankingAccount } from '../banking-account';
import { SelectComparisons } from '../../../../shared/pipes/select.comparisons';
import { NotificationService } from '../../../../shared/notification.service';

@Component({
  selector: 'app-banking-account-select',
  templateUrl: 'select.component.html',
})
export class BankingAccountSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the account to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the banking-accounts currently loaded.
   *
   * @type {BankingAccount[]}
   */
  public accounts: BankingAccount[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {BankingAccountService} accountService
   * @param {NotificationService} notificationService
   */
  constructor(
    private accountService: BankingAccountService,
    private notificationService: NotificationService,
  ) {
    super();
    this.accountService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the account list.
   */
  public ngOnInit(): void {
    this.loadBankingAccounts(1, 10000);
  }

  /**
   * Loads a list of banking-accounts using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadBankingAccounts(page?: number, limit?: number): void {
    const listBankingAccounts = this.accountService
      .listBankingAccounts(page, limit)
      .subscribe((accounts: BankingAccount[]) => {
        this.accounts = accounts;
        listBankingAccounts.unsubscribe();
      });
  }
}
